import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch(err => {
  console.error(err);
  const loader = document.getElementById('app-startup-loader');
  if (loader) {
    const message = document.createElement('p');
    message.textContent = 'Unable to load the application.';

    const retryButton = document.createElement('button');
    retryButton.className = 'startup-retry';
    retryButton.type = 'button';
    retryButton.textContent = 'Refresh page';
    retryButton.addEventListener('click', () => window.location.reload());

    loader.replaceChildren(message, retryButton);
  }
});
